<template>
  <b-form>
    <div class="row">
      <div class="col-md-6 mb-3">
        <div class="d-flex justify-content-between align-items-center">
          <span class="fw-bold"> Surat Permohonan Pengembalian/Perubahan </span>
          <b-button
            variant="success"
            :href="form.file_permohonan_pemuktahiran"
            target="_blank"
            class="text-white m-1"
          >
            <i class="fa fa-download"></i> Unduh
          </b-button>
        </div>
      </div>
      <div class="w-100"></div>
      <div class="col-lg-6 mb-3">
        <label for="nomor_surat_permohonan">
          Nomor Surat <span class="text-danger">*</span>
        </label>
        <b-form-input
          id="nomor_surat_permohonan"
          v-model="form.nomor_surat_permohonan"
          v-validate="'required'"
          name="Nomor Surat"
          style="opacity: 0.7"
          disabled
        ></b-form-input>
      </div>
      <div class="col-lg-6 mb-3">
        <label for="tanggal_surat_permohonan">
          Tanggal Surat <span class="text-danger">*</span>
        </label>
        <b-form-input
          type="date"
          id="tanggal_surat_permohonan"
          v-model="form.tanggal_surat_permohonan"
          v-validate="'required'"
          name="Tanggal Surat"
          style="opacity: 0.7"
          disabled
        ></b-form-input>
      </div>
    </div>
    <div style="border-bottom: 1px solid black"></div>
    <div class="row mb-3">
      <div class="col-md-6 mb-3">
        <label for="jenis_pemuktahiran">Jenis Pemutakhiran</label>
        <v-select
          id="jenis_pemuktahiran"
          v-model="form.jenis_pemuktahiran"
          :options="['Pengembalian', 'Perubahan']"
          name="Jenis Pemutakhiran"
          style="opacity: 0.7"
          disabled
        />
      </div>
      <div v-if="form.jenis_pemuktahiran === 'Perubahan'" class="col-md-6 mb-3">
        <label for="jenis_permohonan_perubahan">Kategori Perubahan</label>
        <v-select
          id="jenis_permohonan_perubahan"
          v-model="form.jenis_permohonan_perubahan"
          :options="[
            'Kesalahan Redaksional',
            'Fakta Baru',
            'Kesalahan Konsiderans',
            'Penambahan KBLI',
            'Lainnya',
          ]"
          name="Kategori Perubahan"
          v-validate="'required'"
          style="opacity: 0.7"
          disabled
        />
      </div>
      <div class="w-100"></div>
      <div class="col-md-6 mb-3">
        <label for="jenis_permohonan">Jenis Permohonan</label>
        <v-select
          id="jenis_permohonan"
          v-model="form.jenis_permohonan"
          :options="['Berusaha', 'Non Berusaha']"
          name="Jenis Permohonan"
          style="opacity: 0.7"
          disabled
        />
      </div>
      <div class="col-md-6 mb-3">
        <label for="nomor_izin_terbit">Nomor Penerbitan Izin</label>
        <b-form-input
          id="nomor_izin_terbit"
          v-model="form.nomor_izin_terbit"
          name="Nomor Penerbitan Izin"
          style="opacity: 0.7"
          disabled
        ></b-form-input>
      </div>
      <div class="col-md-6 mb-3">
        <label for="instansi_pemohon">Instansi Pemohon</label>
        <b-form-input
          id="instansi_pemohon"
          v-model="form.instansi_pemohon"
          name="Instansi Pemohon"
          style="opacity: 0.7"
          disabled
        ></b-form-input>
      </div>
      <div v-if="form.jenis_permohonan === 'Berusaha'" class="col-md-6 mb-3">
        <label for="nib">NIB</label>
        <b-form-input
          id="nib"
          v-model="form.nib"
          name="NIB"
          style="opacity: 0.7"
          disabled
        ></b-form-input>
      </div>
      <div class="col-md-6 mb-3">
        <label for="nomor_permohonan">Nomor Permohonan</label>
        <b-form-input
          id="nomor_permohonan"
          v-model="form.nomor_permohonan"
          name="Nomor Permohonan"
          style="opacity: 0.7"
          disabled
        ></b-form-input>
      </div>
      <div class="col-md-6 mb-3">
        <label for="npwp">NPWP</label>
        <b-form-input
          id="npwp"
          v-model="form.npwp"
          v-mask="'##.###.###.#-###.####'"
          name="NPWP"
          style="opacity: 0.7"
          disabled
        ></b-form-input>
      </div>
      <div class="col-md-6 mb-3">
        <label for="tanggal_penerbitan_izin">Tanggal Penerbitan</label>
        <b-form-input
          type="date"
          id="tanggal_penerbitan_izin"
          v-model="form.tanggal_penerbitan_izin"
          v-validate="'required'"
          name="Tanggal Penerbitan"
          style="opacity: 0.7"
          disabled
        ></b-form-input>
      </div>
      <div class="col-12 mb-3">
        <label for="alasan_pemuktahiran">Alasan Pemutakhiran</label>
        <div style="opacity: 0.7">
          <ckeditor
            id="alasan_pemuktahiran"
            v-model="form.alasan_pemuktahiran"
            :editor="wygEditor"
            disabled
          ></ckeditor>
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-6">
        <div class="d-flex justify-content-between align-items-center">
          <span class="fw-bold"> Dokumen Pendukung Lainnya </span>
          <b-button
            variant="success"
            :href="form.file_dokumen_pendukung"
            target="_blank"
            class="text-white m-1"
            :disabled="!form.file_dokumen_pendukung"
          >
            <i class="fa fa-download"></i> Unduh
          </b-button>
        </div>
      </div>
    </div>
    <legend><strong>Identitas Penanggung Jawab</strong></legend>
    <div class="row">
      <div class="col-md-6 mb-3">
        <label for="nama_penanggungjawab">Nama Penanggung Jawab</label>
        <b-form-input
          id="nama_penanggungjawab"
          v-model="form.nama_penanggungjawab"
          name="Nama Penanggung Jawab"
          style="opacity: 0.7"
          disabled
        ></b-form-input>
      </div>
      <div class="col-md-6 mb-3">
        <label for="jabatan_penanggungjawab"> Jabatan Penanggung Jawab </label>
        <b-form-input
          id="jabatan_penanggungjawab"
          v-model="form.jabatan_penanggungjawab"
          name="Jabatan Penanggung Jawab"
          style="opacity: 0.7"
          disabled
        ></b-form-input>
      </div>
      <div class="col-md-6 mb-3">
        <label for="no_telepon_penanggungjawab"> Nomor Telepon Seluler </label>
        <b-form-input
          id="no_telepon_penanggungjawab"
          v-model="form.no_telepon_penanggungjawab"
          name="Nomor Telepon Seluler"
          style="opacity: 0.7"
          disabled
        ></b-form-input>
      </div>
    </div>
  </b-form>
</template>

<script>
import vSelect from 'vue-select'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import axios from 'axios'

export default {
  components: { vSelect },
  data() {
    return {
      baseapi: localStorage.getItem('baseapi'),
      user: JSON.parse(localStorage.getItem('user')),
      wygEditor: ClassicEditor,
      form: {
        file_permohonan_pemuktahiran: null,
        nomor_surat_permohonan: null,
        tanggal_surat_permohonan: null,
        jenis_pemuktahiran: null,
        jenis_permohonan_perubahan: null,
        jenis_permohonan: null,
        nomor_izin_terbit: null,
        instansi_pemohon: null,
        nib: null,
        npwp: null,
        nomor_permohonan: null,
        tanggal_penerbitan_izin: null,
        alasan_pemuktahiran: null,
        file_dokumen_pendukung: null,
        nama_penanggungjawab: null,
        jabatan_penanggungjawab: null,
        no_telepon_penanggungjawab: null,
      },
    }
  },
  methods: {
    async nextForm() {
      return true
    },

    async loadData() {
      const id = this.$route.query.id_pemutakhiran
      if (!id) {
        this.$router.push('/app/perubahan')
        return
      }

      const res = await axios.get(
        `${this.baseapi}api/pemuktahiran/${id}`,
        this.getApiOption(),
      )
      const resData = res.data.data
      for (const k in this.form) {
        this.form[k] = resData[k]
      }
    },

    getApiOption() {
      return {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken,
        },
      }
    },
  },
  mounted() {
    this.loadData()
  },
}
</script>
